/**
 * Route table for the SPA.
 * Each page renders real React JSX under `views/` and shares `MainLayout`.
 */
import { lazy, type ComponentType } from 'react';

const HomeOnePage = lazy(() => import('./views/HomeOne'));
const AboutPage = lazy(() => import('./views/About'));
const FaqPage = lazy(() => import('./views/Faq'));
const TermsPage = lazy(() => import('./views/Terms'));
const ConnectPage = lazy(() => import('./views/Connect'));
const ReportIssuePage = lazy(() => import('./views/ReportIssue'));
const ShopGridPage = lazy(() => import('./views/ShopGrid'));
const ProductDetailsPage = lazy(() => import('./views/ProductDetails'));
const AccountPage = lazy(() => import('./views/Account'));
const OrderDetailsPage = lazy(() => import('./views/OrderDetails'));
const CartPage = lazy(() => import('./views/Cart'));
const CheckoutPage = lazy(() => import('./views/Checkout'));
const PaymentResultPage = lazy(() => import('./views/PaymentResult'));
const ContactPage = lazy(() => import('./views/Contact'));
const NotFoundPage = lazy(() => import('./views/NotFound'));

export type FooterVariant = 'home' | 'inner';

export type AppRoute = {
  path: string;
  name: string;
  title: string;
  /** Footer layout: home pages use newsletter footer; inner pages use compact footer. */
  footer: FooterVariant;
  Component: ComponentType;
};

export const appRoutes: AppRoute[] = [
  { path: '/', name: 'HomeOne', title: 'Home', footer: 'home', Component: HomeOnePage },
  { path: '/about', name: 'About', title: 'About Us', footer: 'inner', Component: AboutPage },
  { path: '/faq', name: 'Faq', title: "FAQ's", footer: 'inner', Component: FaqPage },
  { path: '/terms', name: 'Terms', title: 'Terms & Conditions', footer: 'inner', Component: TermsPage },
  { path: '/connect', name: 'Connect', title: 'Get Connected', footer: 'inner', Component: ConnectPage },
  { path: '/report', name: 'ReportIssue', title: 'Report Issue', footer: 'inner', Component: ReportIssuePage },
  { path: '/shop', name: 'ShopGrid', title: 'Shop', footer: 'inner', Component: ShopGridPage },
  { path: '/product', name: 'ProductDetails', title: 'Product Details', footer: 'inner', Component: ProductDetailsPage },
  { path: '/account', name: 'Account', title: 'Account', footer: 'inner', Component: AccountPage },
  { path: '/account/order', name: 'OrderDetails', title: 'Order Details', footer: 'inner', Component: OrderDetailsPage },
  { path: '/cart', name: 'Cart', title: 'Cart', footer: 'inner', Component: CartPage },
  { path: '/checkout', name: 'Checkout', title: 'Checkout', footer: 'inner', Component: CheckoutPage },
  { path: '/payment/result', name: 'PaymentResult', title: 'Payment', footer: 'inner', Component: PaymentResultPage },
  { path: '/contact', name: 'Contact', title: 'Contact Us', footer: 'inner', Component: ContactPage },
  { path: '/404', name: 'NotFound', title: '404', footer: 'inner', Component: NotFoundPage },
];
